import { Map as immutableMap } from 'immutable';
import { getField, updateField } from 'vuex-map-fields';

const STATE = immutableMap({
  date: Date.now(),
  version: `${(process.env.PACKAGE_VERSION || '0')}_xt52de16`,
});

export const state = () => STATE.toJS();

export const getters = {
  getField,
};

export const mutations = {
  reset(state) {
    Object.assign(state, {
      ...STATE.toJS(),
      date: Date.now(),
    });
  },
  updateField,
};

export const actions = {
  checkVersion(context) {
    if (!context.state.version
      || !STATE.toJS().version
      || context.state.version !== STATE.toJS().version
    ) {
      console.log('checkVersion - reset', {
        local: context.state.version,
        state: STATE.toJS().version,
      });
      context.dispatch('reset', null, {root: true});
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
